// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import { createGetOpts, config } from '@src/utils/sliders';

import type {
  TableSearchFilterType,
  TableSearchExtentType
} from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as TableContent from '@components/popups/content/Table';

const optionsFunc = (values, extents, step, margin) => {
  // hide slider via ErrorBoundary
  if (extents[0] === extents[1]) throw new Error("min and max can't be equal");

  return {
    start: values,
    range: {
      min: extents[0],
      max: extents[1]
    },
    step: step,
    margin: margin,
    connect: [false, true, false]
  };
};

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: TableSearchFilterType | void,
  extent: TableSearchExtentType,
  disableTabIndex?: boolean
};

const Popup = () => <QuestionMarkPopup initialContent={TableContent} />;

export default class TableRange extends React.Component<PropsType> {
  render() {
    const { value, extent } = this.props;
    const getOpts = createGetOpts(extent, optionsFunc, config.table);

    return (
      <GenericSlider
        title={'Table'}
        getOpts={getOpts}
        value={value || extent}
        userValue={value}
        extent={extent}
        onSliderUpdate={values =>
          this.props.onSliderUpdate('UPDATE_TABLE_PERCENT', values.map(Number))
        }
        Popup={Popup}
        formatter={num => `${num} %`}
        inputWidth={'60px'}
        inputStep={config.table.stepSize}
        inputStepMargin={config.table.margin}
        disableTabIndex={this.props.disableTabIndex}
        inputs
      />
    );
  }
}
